import React from 'react';
import { Box, Container, Divider, Stack, Typography } from '@mui/material';
import { useAuth } from '../auth/AuthContext';

/**
 * Minimal, enterprise-style footer (sticky-friendly).
 * Positioned so the text sits slightly above the bottom edge (not vertically centered).
 * Customer branding: Jetfin.
 */
export default function Footer() {
  const { user } = useAuth();
  if (!user) return null;

  const year = new Date().getFullYear();

  return (
    <Box sx={{ mt: 0 }}>
      <Divider />
      <Box
        component="footer"
        sx={{
          bgcolor: 'background.paper',
          minHeight: 52,
          display: 'flex',
          alignItems: 'flex-end', // ⬅ text sits lower (slightly above bottom)
        }}
      >
        <Container maxWidth="xl" sx={{ pt: 0.75, pb: 1 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 0.5, sm: 2 }}
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, lineHeight: 1.1 }}>
              © {year} Jetfin. All rights reserved.
            </Typography>

            <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.1 }}>
              {/* Powered by SoftDOF Supercomputing */}
            </Typography>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
